import type { CreditFocusPresentation } from "./creditFocus";
import { CalloutTooltip } from "./PlanValueProps";

export const CreditFocusOptOutTitle = ({
  creditFocus,
}: {
  creditFocus: CreditFocusPresentation;
}) => (
  <>
    No other provider can offer you{" "}
    {creditFocus.calloutText ? (
      <CalloutTooltip
        id="credit-focus-opt-out-amount"
        text={creditFocus.calloutText}
      >
        {creditFocus.amount}
      </CalloutTooltip>
    ) : (
      creditFocus.amount
    )}{" "}
    in {creditFocus.optOut.credits}. Are you sure?
  </>
);
